import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {FieldDefinition} from '@shared/models/field-definition';
import {DialogService} from '@shared/services/dialog-service';

@Component({
    standalone: false,
    selector: 'particle-hyperlink-country-selector-cell-viewer',
  templateUrl: './hyperlink-country-selector-cell-viewer.component.html',
  styleUrls: ['./hyperlink-country-selector-cell-viewer.component.scss']
})
export class HyperlinkCountrySelectorCellViewerComponent implements OnInit, CellComponent {
  item: any;
  sourceType: string;
  fieldDefinition: FieldDefinition;
  invalidateSubject?: InvalidateSubject;
  disabled: boolean;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();

  constructor(private dialogService: DialogService) {
  }

  ngOnInit() {
  }

  onClicked(action: string) {
    this.dialogService.showCellEditorDialog(this.item, this.fieldDefinition).subscribe(state => {
      if (state.action === 'OK') {
        this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: action}});
      }
    });
  }
}
